

import React from "react";
import "./Foodclientmanagement.css";

import Logisticsclientlanding from "../Logistics/Logisticsclientlanding";

const Ridersmanagment = () => {
    return (
        <div className="company-container" style={{ marginTop: "57px" }}>
            <div className="component-display">
                <Logisticsclientlanding title="Logistics" />
            </div>
        </div>
    );
};

export default Ridersmanagment;